import { FC, TextareaHTMLAttributes } from 'react';
import { Label, TextArea } from './Message.styles';

interface MessageProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: string;
}

const Message: FC<MessageProps> = ({ value, onChange, rows = 5, placeholder, name, label }) => {
	return (
		<Label>
			{label}
			<TextArea
				placeholder={placeholder}
				value={value}
				rows={rows}
				onChange={onChange}
				name={name}
			/>
		</Label>
	);
};

export default Message;
